import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Utils } from "../../Utils";
import DynamicPrompt from "../../Components/ModalPopup/DynamicSelect";
import { useDispatch, useSelector } from "react-redux";
import { createPromptStart, getPromptStart, resetState, updatePromptStart } from "../../Store/Slices/promptSlice";
import { toast } from "react-toastify";
import Toast from "../../Components/Toast";
import Loader from "../../Components/Loader";

const Ai = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let promptData = useSelector((state) => state?.prompt);
  let [headings, setHeadings] = useState([]);
  let [selectedOptions, setSelectedOptions] = useState([]);
  let [assistantPrompt, setAssistantPrompt] = useState("Research '${Leads.Company}': Provide company background(founded year, founders, HQ, size, industry), business model, products / services, target market, customer base, digital maturity, pain points, challenges, recent news(past year), leadership team, financial performance, competitors, partnerships, and technology use.");
  let [generatedPrompt, setGeneratedPrompt] = useState('');
  let [isShowGeneratedPrompt, setIsShowGeneratedPrompt] = useState(false);
  let [options, setOptions] = useState([]);
  let [promptId, setPromptId] = useState('');
  let initialAIPrompt = "Compare the following '${Leads.Company}' data with '${Company}' generate a strategic business report.";


  let [initialPrompt, setInitialPrompt] = useState("Generate a Strategic Client Assessment Report for '${Leads.Company}', incorporating strategic context in relation to '${Company}'.");
  let [middlePrompt, setMiddlePrompt] = useState("Include the following sections only:");
  let [endPrompt, setEndPrompt] = useState("Use a formal, executive tone and ensure the report is insightful, concise, and strategic. Emphasize potential opportunities, alignment areas, and business advantages that may arise in context of ${Company}'s expertise.");
  useEffect(() => {
    dispatch(getPromptStart())
  }, [])

  useEffect(() => {
    if (promptData?.data?.length > 0) {
      setPromptId(promptData?.data?.[0]?._id)
      setAssistantPrompt(promptData?.data?.[0]?.assistant_prompt || assistantPrompt)
      // setGeneratedPrompt(promptData?.data?.[0]?.generated_prompt || initialAIPrompt)
      setSelectedOptions(promptData?.data?.[0]?.prompt_list)
      setOptions(promptData?.data?.[0]?.prompt_list.map((data) => data.key))
      setIsShowGeneratedPrompt(true)
      setInitialPrompt(promptData?.data?.[0]?.initialPrompt);
      setEndPrompt(promptData?.data?.[0]?.endPrompt);
    }
  }, [promptData])

  useEffect(() => {
    handleChangeGeneratedPrompt(initialPrompt + ' ' + endPrompt)
  }, [initialPrompt, endPrompt])

  useEffect(() => {
    const headingsArr = selectedOptions
      .filter(item => item.is_include)
      .map(item => item.key);
    setHeadings(headingsArr)
  }, [selectedOptions])

  useEffect(() => {
    if (promptData?.createStatus || promptData?.updateStatus) {
      toast.success(promptData.message, {
        autoClose: 2000,
        onClose: () => {
          dispatch(resetState())
          // dispatch(getPromptStart())
        }
      });
    }
    if (promptData?.createStatus === false || promptData?.updateStatus === false) {
      toast.error(promptData.message, {
        autoClose: 2000,
        onClose: () => {
          dispatch(resetState())
        }
      });
    }
  }, [promptData.createStatus, promptData.updateStatus])

  const handleSave = () => {
    if (assistantPrompt.length > 400) {
      toast.info('The prompt length should be 400 characters or fewer', {
        autoClose: 2000,
      })
    } else {
      if (generatedPrompt !== '' && assistantPrompt !== '') {
        let payload = {
          prompt_list: selectedOptions,
          generated_prompt: generatedPrompt,
          assistant_prompt: assistantPrompt,
          initialPrompt: initialPrompt,
          endPrompt: endPrompt
        }
        // console.log('create payload:', payload)
        dispatch(createPromptStart(payload))
      }
    }
  };

  const handleChangeAssistantPrompt = (e) => {
    setAssistantPrompt(e.target.value)
  }

  const handleChangeGeneratedPrompt = (value) => {
    setGeneratedPrompt(value)
  }

  const handleUpdate = () => {
    if (assistantPrompt.length > 400) {
      toast.info('The prompt length should be 400 characters or fewer', {
        autoClose: 2000,
      })
    } else {
      if (generatedPrompt !== '' && assistantPrompt !== '') {
        let payload = {
          prompt_list: selectedOptions,
          generated_prompt: generatedPrompt,
          assistant_prompt: assistantPrompt,
          initialPrompt: initialPrompt,
          endPrompt: endPrompt
        }
        // console.log('update payload:', payload)
        dispatch(updatePromptStart({ id: promptId, payload: payload }))
      }
    }
  };

  return (
    <>
      <Toast />
      <Loader isVisible={promptData?.isLoading} />
      <div className="navbar sticky-top bg-light-subtle border-bottom border-light-subtle px-0 tb-header">
        <div className="ps-3 me-auto">
          <span className="ps-2 fw-semibold fs-5">Prompt</span>
        </div>
        <div className="pe-3 ms-auto">
          <div className="btn-group">
            <button type="button" className="btn btn-outline-primary btn-blue rounded-2"
              onClick={() => navigate(Utils.getNavigationUrl('/settings'))}><span>Cancel</span></button>
            {(promptData?.data?.length > 0) ?
              <button type="button" className="btn btn-primary btn-blue rounded-2"
                onClick={handleUpdate}><span>Update</span></button>
              :
              <button type="button" className="btn btn-primary btn-blue rounded-2"
                onClick={handleSave}><span>Save</span></button>
            }
          </div>
        </div>
      </div >
      <div className="content-section">
        <div className="container-fluid overflow-y-auto" style={{ height: 'calc(100vh - 13.8vh)' }}>
          <DynamicPrompt
            selectedOptions={selectedOptions}
            setSelectedOptions={setSelectedOptions}
            generatedPrompt={generatedPrompt}
            setGeneratedPrompt={setGeneratedPrompt}
            isShowGeneratedPrompt={isShowGeneratedPrompt}
            setIsShowGeneratedPrompt={setIsShowGeneratedPrompt}
            options={options}
            setOptions={setOptions}
            handleChangeGeneratedPrompt={handleChangeGeneratedPrompt}
            assistantPrompt={assistantPrompt}
            setAssistantPrompt={setAssistantPrompt}
            handleChangeAssistantPrompt={handleChangeAssistantPrompt}
            initialPrompt={initialPrompt}
            setInitialPrompt={setInitialPrompt}
            middlePrompt={middlePrompt}
            endPrompt={endPrompt}
            setEndPrompt={setEndPrompt}
          />
        </div>
      </div>
    </>
  );
}

export default Ai;
